/* eslint-disable no-useless-escape */
import pageContext from '../lib/salvo-lite/context'

import ScrollTools from './components/ScrollTools'
import Slider from './components/Slider'
import Accordion from './components/Accordion'
import FaqPage from './components/FaqPage'
import ContentPage from './components/ContentPage'
import NewsletterPopup from './components/NewsletterPopup'
import Instagram from './components/Instagram'
import CollectionFilterDropdown from './components/CollectionFilterDropdown'
import GiftCardSelector from './components/GiftCardSelector'
import DetectBackground from './components/DetectBackground'
import PopoutCart from './components/PopoutCart'
import AjaxCart from './components/AjaxCart'
import Cart from './components/Cart'
import GiftCardAddCart from './components/GiftCardAddCart'
import ToggleClasses from './components/ToggleClasses'
import QuestionnaireRedirect from './components/QuestionnaireRedirect'
import AccordionV2 from './components/AccordionV2'

const components = {
    'scroll': ScrollTools,
    'slider': Slider,
    'accordion': Accordion,
    'accordion-v2': AccordionV2,
    'faqpage': FaqPage,
    'contentpage': ContentPage,
    'newsletterpopup': NewsletterPopup,
    'instagram': Instagram,
    'collectionfilterdropdown': CollectionFilterDropdown,
    'giftcardselector': GiftCardSelector,
    'detectbackground': DetectBackground,
    'popout-cart': PopoutCart,
    'ajax-cart': AjaxCart,
    'cart': Cart,
    'gift-card-add-to-cart': GiftCardAddCart,
    'toggle-classes': ToggleClasses,
    'questionnaire-redirect': QuestionnaireRedirect
}

const pages = {
}

class Theme {
    constructor () {
        this._components = []
        this._componentsById = {}
    }

    registerComponents () {
        for (let key in components) {
            var ComponentConstructor = components[key]
            var elements = document.querySelectorAll(`.js-component__${key}, [data-${key}]`)
            for (let elem of elements) {
                var instance = new ComponentConstructor(this, elem)
                this._components.push(instance)
                var id = elem.dataset.componentId
                if (id) {
                    this._componentsById[id] = instance
                }
                instance.onInit()
            }
        }
        window.ThemeComponents = this._components
        window.ThemeComponentsId = this._componentsById
        window.__Theme = this
    }

    registerPages () {
        var context = pageContext.getTemplate()
        for (let page in pages) {
            if (page === context) {
                var instance = new pages[page](this)
                instance.onInit()
            }
        }
    }

    getComponents () {
        return this._components
    }

    getComponentsById (id) {
        return this._componentsById[id]
    }

    getComponentsByType (componentConst, includeSubclasses = true) {
        var r = []
        for (let c of this._components) {
            if (includeSubclasses && c instanceof componentConst) {
                r.push(c)
            } else if (c.constructor === componentConst) {
                r.push(c)
            }
        }
        return r
    }
}

export default Theme



// WEBPACK FOOTER //
// ./resources/scripts/Theme.js